import React from 'react';
import '../styles/landing-page.css';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleJoinClick = () => {
    navigate('/join');
  };

  return (
    <div className="container">
      <h1 className="site-name">Curios.Dog</h1>
      <h2 className="coming-soon">Coming Soon</h2>
      <h3 className="tagline">Because curiosity killed the cat 🐈‍⬛</h3> {/* Add tagline here */}

      <div className="dog-image-wrapper">
        <div className="question-mark">?</div>
        <img
          src={`${process.env.PUBLIC_URL}/curios-dog.jpeg`}
          alt="Curious Dog"
          className="dog-image"
        />
      </div>

      <div className="join-waitlist">
        <button className="join-btn" onClick={handleJoinClick}>
          Join The Waiting List
        </button>
      </div>

      <div className="claim-username">
        Reserve your spot now and claim your username!
      </div>
      <Footer /> {/* Add the Footer at the bottom of the page */}
    </div>
  );
};

export default LandingPage;
